import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AmbassadorContext = createContext();

export const AmbassadorProvider = ({ children }) => {
  const [ambassador, setAmbassador] = useState(null);
  const [stats, setStats] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('nofee_amb_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchMe();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const api = axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  const fetchMe = async () => {
    try {
      const res = await axios.get(`${API}/rewards/ambassadors/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAmbassador(res.data.ambassador);
      setStats(res.data.stats);
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const signup = async (data) => {
    const res = await axios.post(`${API}/rewards/ambassadors/signup`, data);
    localStorage.setItem('nofee_amb_token', res.data.token);
    setToken(res.data.token);
    setAmbassador(res.data.ambassador);
    return res.data;
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/rewards/ambassadors/login`, { email, password });
    localStorage.setItem('nofee_amb_token', res.data.token);
    setToken(res.data.token);
    setAmbassador(res.data.ambassador);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('nofee_amb_token');
    setToken(null);
    setAmbassador(null);
    setStats(null);
  };

  return (
    <AmbassadorContext.Provider
      value={{ ambassador, stats, token, loading, signup, login, logout, fetchMe, api }}
    >
      {children}
    </AmbassadorContext.Provider>
  );
};

export const useAmbassador = () => useContext(AmbassadorContext);
